<template>
  <div class="range-wrap range-wrap-date-picker" v-click-outside="pageOnClosed">
    <div class="triangle-container">
      <div class="triangle-up"></div>
    </div>
    <lego-icon-button @click="pageOnClosed" iconType="df" icon="delete" class="ui-icon i-closed" />
    <div class="time-container">
      <div class="datepicker rangedate">
        <multi-date-picker-extend-tab
          ref="datepicker"
          :isDashboard="isDashboard"
          :index1Value="index1Value"
          :isLogDate="isLogDate"
          :autoOpen="true"
          :isPerformance="isPerformance"
          :isMonitoringPerformance="isMonitoringPerformance"
          :dateValueOld="dateValueOld"
          :datePickerPositionUp="datePickerPositionUp"
          @tabChange="onTabChange"
          @dataChange="onDataChanged"
          @input="onSearch"
          @updateDateValueOld="updateDateValueOld"
        />
      </div>
    </div>

    <div class="refresh-container" v-if="refreshTime">
      <scpm-sub-title class="ui-stitle">{{ $t('label.refreshCycle') }}</scpm-sub-title>
      <lego-segment-wrapper v-model="refreshInterval" :isDatePicker="true">
        <lego-segment-button value="1">1 {{ $t('label.onlyMin') }}</lego-segment-button>
        <lego-segment-button value="3">3 {{ $t('label.minutes') }}</lego-segment-button>
        <lego-segment-button value="5">5 {{ $t('label.minutes') }}</lego-segment-button>
        <lego-segment-button value="10">10 {{ $t('label.minutes') }}</lego-segment-button>
        <lego-segment-button value="15">15 {{ $t('label.minutes') }}</lego-segment-button>
      </lego-segment-wrapper>
    </div>
    <!-- // refresh END -->

    <div class="button-wrap right">
      <lego-button medium @click="pageOnClosed">{{ $t('button.cancel') }}</lego-button>
      <lego-button medium main @click="onConfirm" :disabled="!valueChanged">{{
        $t('button.confirm')
      }}</lego-button>
    </div>
  </div>
</template>

<script>
import i18nMixin from '@/mixins/i18n.mixin.js';
import multiDatePickerExtendTab from './multiDatePickerExtendTab';
import legoEventBus from '@/lego-component/utils/eventBus/eventBus';

export default {
  emits: ['save', 'close', 'opened'],
  mixins: [i18nMixin],
  props: {
    isPerformance: { type: Boolean, default: false },
    isMonitoringPerformance: { type: Boolean, default: false },
    index1Value: { type: String, default: '30m' },
    refreshTime: {
      type: Boolean,
      default: true
    },
    datePickerPositionUp: {
      type: Boolean,
      default: false
    },
    openByToggle: { type: Boolean, default: false },
    intervalTime: {
      type: String,
      default: '1'
    },
    isDashboard: { type: Boolean, default: false },
    isLogDate: {
      type: Boolean,
      default: false
    }
  },
  components: {
    multiDatePickerExtendTab
  },
  data() {
    return {
      refreshInterval: '',
      items: [],
      lastInterval: '1',
      valueChanged: false,
      lastChanged: false,
      activeTab: 1,
      dateValueOld: []
    };
  },
  created() {
    this.refreshInterval = this.intervalTime;
  },
  computed: {},
  watch: {
    refreshInterval() {
      if (this.lastInterval != this.refreshInterval) {
        this.valueChanged = true;
      } else {
        this.valueChanged = this.lastChanged;
      }
    }
  },
  mounted() {
    legoEventBus.$on('click-outside-datePicker', () => this.pageOnClosed());
  },

  beforeMount() {
    legoEventBus.$off('click-outside-datePicker', () => this.pageOnClosed());
  },
  methods: {
    /*************
     * page
     *************/
    pageOnClosed() {
      if (this.openByToggle) {
        this.$emit('opened');
        return;
      }

      if (this.dateValueOld.length === 0 && this.$refs.datepicker) {
        this.dateValueOld = [this.getCurrentDate().queryStartDt, this.getCurrentDate().queryEndDt];
      }

      if (this.$refs.datepicker) {
        this.$refs.datepicker.loadDefault();
      }

      this.cancelRefreshInterval();
      this.$emit('close');
    },
    onConfirm() {
      this.save();
    },
    onDataChanged(changed) {
      this.lastChanged = changed;
      if (this.lastInterval != this.refreshInterval) {
        this.valueChanged = true;
      } else {
        this.valueChanged = changed;
      }
    },
    save() {
      if (this.$refs.datepicker.checkValidDate()) {
        this.$refs.datepicker.setDefalut(true);
        this.$emit('save', {
          refresh: this.refreshInterval,
          date: this.getCurrentDate()
        });
        this.lastInterval = this.refreshInterval;
        this.dateValueOld = [this.getCurrentDate().queryStartDt, this.getCurrentDate().queryEndDt];
        this.$emit('close');
      }
    },
    onTabChange(tabIdx) {
      this.activeTab = tabIdx || 1;
    },
    onSearch() {},
    getCurrentDate() {
      return this.$refs.datepicker.getCurrentDate();
    },
    setDate(d) {
      if (typeof d !== 'string') {
        this.refreshInterval = d.refreshInterval.toString();
      }
      this.$refs.datepicker.setDate(d);
    },
    cancelRefreshInterval() {
      this.refreshInterval = this.intervalTime ? this.intervalTime : this.lastInterval;
    },
    setDefalut(isCheck = false, isReset = false) {
      this.$refs.datepicker.setDefalut(isCheck, isReset);
      this.lastInterval = this.refreshInterval;
      this.valueChanged = false;
      this.lastChanged = false;
    },
    updateDateValueOld(value) {
      this.dateValueOld = value;
    }
  }
};
</script>

<style lang="scss" scoped>
.refresh-container {
  height: 72px;
}

.triangle-up {
  position: absolute;
  box-shadow: 0px 8px 15px 2px rgba(23, 25, 28, 0.15), 0px 0px 4px 0px rgba(23, 25, 28, 0.2),
    0px -1px 4px 0px rgba(23, 25, 28, 0.15), 0px -1px 4px 0px rgba(23, 25, 28, 0.1) inset;
  background-color: #fff;
  border-radius: 4px;
}
.triangle-up:after {
  content: '';
  position: absolute;
  width: 0;
  height: 0;
  top: 0%;
  left: 50%;
  box-sizing: border-box;
  border: 5px solid white;
  border-color: transparent transparent white white;
  transform-origin: 0 0;
  transform: rotate(135deg);
  box-shadow: -3px 3px 3px 0 rgba(0, 0, 0, 0.2);
}
.triangle-container {
  position: absolute;
  right: 12px;
  top: 0px;
}
.range-wrap {
  :deep(.refresh-container .lego-segment-wrapper .lego-segment-button) {
    min-width: 79px !important;
  }
}
.range-wrap-date-picker {
  right: -8px !important;
  border-radius: 4px;
  :deep .lego-dropdown__items {
    z-index: 3999 !important;
  }
}
:deep {
  .lego-button--solid.lego-button--primary {
    margin-left: 16px !important;
  }
  .lego-tab__label-underline {
    border-bottom: none;
    border: none;
    background: transparent;
  }
  .lego-tab__content-wrapper {
    border-top: 1px solid #e3e4e8 !important;
  }

  .lego-tab__label-underline:after {
    bottom: 0;
    border-bottom: 0;
    height: 2px;
  }

  .lego-tab__label-underline--active:after {
    border: none;
    background: #2c59d9;
    border-radius: 100px;
  }
}
</style>
